import { Roe } from '@app/models/payroll/roe.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class RoeAmendmentColumn extends BadgeColumn<Roe> {
    title = 'table.roes.type';
    property = 'originalRoeUuid';
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(roe: Roe): BadgeDisplay {
        if (roe?.originalRoeUuid) {
            return {
                type: 'purple',
                label: 'table.roes.typeOptions.amendment',
            };
        }

        return {
            type: 'default',
            label: 'table.roes.typeOptions.original',
        };
    }
}
